<template>
    <div>
        <div class="section">
            <div class="header">
                <div class="header__title">
                    <div v-if="num !== ''" class="subtitle">
                        <span class="subtitle__text">{{ num }}</span>
                        <span class="subtitle__separator"></span>
                        <span class="subtitle__text">Проекты</span>
                    </div>
                    <h2 class="title title--uppercase">{{ title }}</h2>
                </div>

                <div class="header__text-wrapper">
                    <slot name="text">
                        <p class="header__text" :style="{ maxWidth: textWidth }">{{ text }}</p>
                    </slot>
                </div>
            </div>

            <slot v-if="customContent"></slot>

            <div class="content" v-else-if="!customContent">
                <div class="content__header" v-if="contentHeader">
                    <div class="content__button" @click="$emit('refresh')">
                        <welcome-refresh-button>Обновить</welcome-refresh-button>
                    </div>

                    <div class="content__link-wrapper" v-if="projectLink">
                        <a class="link content__link" :href="projectLink">
                            <span>На страницу проекта</span>
                        </a>
                    </div>
                </div>

                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import WelcomeRefreshButton from "./WelcomeRefreshButton.vue";

export default {
    name: 'WelcomeSection',
    components: {WelcomeRefreshButton},
    props: {
        title: {
            type: String,
            required: true,
        },
        text: {
            type: String,
        },
        textWidth: {
            type: String,
            default: null,
        },
        num: {
            type: String,
            required: true,
        },
        contentHeader: {
            type: Boolean,
            default: false,
        },
        customContent: {
            type: Boolean,
            default: false,
        },
        projectLink: {
            type: String,
            default: null,
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";
.section {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 8rem;
    @media (max-width: 1159px) {
        margin-top: 7rem;
    }
}
.header {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    @media (max-width: 1159px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: stretch;
    }
}
.header__title {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.header__text-wrapper {
    flex: 1 1;
    color: #4E4E4E;
    font-size: 2rem;
    line-height: 140%;
    font-weight: 400;
    margin-left: 1.6rem;
    margin-top: 19px;
    @media (max-width: 1159px) {
        margin-left: 0;
        margin-top: 2.4rem;
    }
    @media (max-width: 560px) {
        font-size: 1.8rem;
        max-width: 100% !important;
    }
}
.header__text {
    @media (max-width: 1159px) {
        max-width: 100% !important;
    }
}
.subtitle {
    display: flex;
    align-items: center;
}
.subtitle__text {
    color: #A9B1C2;
    font-size: 2.2rem;
    letter-spacing: -1.25px;
    white-space: nowrap;
    font-family: $font-family-secondary;
    text-transform: uppercase;
    font-weight: 600;
    @media (max-width: 560px) {
        font-size: 1.4rem;
    }
}
.subtitle__separator {
    width: 14.3rem;
    height: 1px;
    background-color: #A9B1C2;
    margin: 0 2.3rem;
    @media (max-width: 560px) {
        width: 4.9rem;
    }
}
.title {
    font-size: 4rem;
    max-width: 49.1rem;
    margin-top: 1rem;
    @media (max-width: 1159px) {
        margin-top: 0.8rem;
        max-width: 100%;
    }
    @media (max-width: 560px) {
        font-size: 2.8rem;
    }
}
.content {
    border-radius: 10px;
    background: #F8F9FC;
    padding: 3.1rem 3rem 3.5rem;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: relative;
    margin-top: 4.8rem;
    margin-bottom: 116px;
    @media (max-width: 1159px) {
        margin-top: 2.4rem;
        padding: 0;
        background: unset;
    }
}
.content__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2.8rem;
    @media (max-width: 1159px) {
        display: none;
    }
    @media (max-width: 600px) {
        display: block;
        margin-bottom: 2.4rem;
    }
}
.content__button {
    font-size: 1.6rem !important;
    @media (max-width: 1159px) {
        display: none;
    }
}
.content__link-wrapper {
    flex: 1 1;
    display: flex;
    justify-content: flex-end;
    @media (max-width: 1159px) {
        display: none;
    }
    @media (max-width: 600px) {
        display: block;
    }
}
.content__link {

}
</style>
